export default __webpack_public_path__ + "static/media/data-swapp.105e5da2.svg";